import React from "react";
import { Button } from "../../../components/ui/button";
import Spinner from "../../../components/ui/spinner";
import { CheckIcon, EllipsisIcon, Unplug } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../../../components/ui/dropdown-menu";
import { ConnectionStatus } from "../mock-providers";

interface ConnectButtonProps {
    status: ConnectionStatus;
    onConnect: () => void;
    onDisconnect?: () => void;
}

export function ConnectButton({ status, onConnect, onDisconnect }: ConnectButtonProps) {
    if (status === "authorizing") {
        return (
            <Button variant="outline" size="sm" disabled>
                <Spinner className="mr-2 h-4 w-4" />
                Authorizing...
            </Button>
        );
    }

    if (status === "connected") {
        return (
            <div className="flex items-center gap-1">
                <Button variant="outline" size="sm" className="pointer-events-none text-confirmation">
                    <CheckIcon className="mr-2 h-4 w-4" />
                    Connected
                </Button>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
                            <EllipsisIcon className="h-4 w-4 text-muted-foreground" />
                            <span className="sr-only">More options</span>
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-48 rounded-lg" side="bottom" align="end" sideOffset={6}>
                        <DropdownMenuItem className="cursor-pointer" onClick={onDisconnect}>
                            <Unplug className="me-1 h-4 w-4" />
                            Disconnect
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        );
    }

    return (
        <Button variant="outline" size="sm" onClick={onConnect}>
            Connect
        </Button>
    );
}
